import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalUploadDirective } from '@modules/directives/global-upload.directive';
import { GlobalOperationsModule } from '../helper-modules/global-operations.module';
import { FileOperationsWrapperComponent } from './file-operations-wrapper/file-operations-wrapper.component';
import { GlobalAccessComponent } from './global-access/global-access.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { CreateAlbumComponent } from '@mainrepo/app/shared-standalone-components/file-operations/create-album/create-album.component';
import { CreateFolderComponent } from '@common-standalone/file-operations/create-folder/create-folder.component';
import { SematicSearchStatusComponent } from '@mainrepo/app/standalone-components/advanced-search/sematic-search-status/sematic-search-status.component';

@NgModule({
  declarations: [
    HomeComponent,
    FileOperationsWrapperComponent,
    GlobalAccessComponent
  ],
  imports: [
    CommonModule,    
    HomeRoutingModule,
    GlobalOperationsModule,
    GlobalUploadDirective,
    CreateAlbumComponent,
    CreateFolderComponent,
    SematicSearchStatusComponent
  ],
  providers:[DatePipe]
})
export class HomeModule { }
